import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCreateARoom = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 10.5,
	height: 10.5,
	viewBox: "0 0 10.5 10.5",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("g", { id: "a" }),
		/* @__PURE__ */ _jsx("g", {
			id: "b",
			children: /* @__PURE__ */ _jsx("g", {
				id: "c",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M10.5,1.5v7.5c0,.83-.67,1.5-1.5,1.5H1.5c-.83,0-1.5-.67-1.5-1.5V1.5C0,.67,.67,0,1.5,0h7.5c.83,0,1.5,.67,1.5,1.5Zm-1.12,0c0-.21-.17-.38-.38-.38H1.5c-.21,0-.38,.17-.38,.38v7.5c0,.21,.17,.38,.38,.38h7.5c.21,0,.38-.17,.38-.38V1.5Zm-1.4,3.75c0,.31-.23,.56-.54,.56h-1.69v1.69c0,.31-.23,.56-.54,.56s-.56-.25-.56-.56v-1.69h-1.67c-.29,0-.56-.25-.56-.56s.27-.56,.56-.56h1.69v-1.69c0-.31,.29-.56,.58-.56s.54,.25,.54,.56v1.69h1.69c.33,0,.5,.25,.5,.56Z",
					fill: "#231f20"
				})
			})
		})
	]
});
const ForwardRef = forwardRef(SvgCreateARoom);
export default ForwardRef;
